export default "__VITE_ASSET__QC134eRR__"